import React from 'react'
import {handleGoToHomeClickACB} from "../utilities.js"

export function ErrorView (props) {
  return (
        <div className='d-flex flex-column align-items-center'>
          <img  class="ml-3 mt-5 w-50 align-center content-center " src="https://media.giphy.com/media/55d4cDB5zXccQlA8Ig/giphy.gif" alt="error" />
          <div class="ml-3 mt-5 align-center content-center ">
            <h3 className='text-color harry-font'>There seems to be an error</h3>
          </div>
          <div class="ml-3 mt-2 align-center content-center ">
            <button class="secondary_btn"  onClick={handleGoToHomeClickACB} id="authButton">Go to Home</button>
          </div>
        </div>
  );

  const error = useRouteError();
  console.log(error);
}